import { Modal } from "antd";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Contexts/AuthContext";
import useLoading from "../../../Hooks/useLoading";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from "react-router-dom";
import { CreatOpportunitiesPanelsAPI, GetAllYearsFromProjects } from "../../../API/OpportunitiesPanelsAPI";
import { useContext, useEffect, useState } from "react";
import { OpportunityMappingModel } from "../../../Models/OpportunityMappingModel";
import { GetAllOpportunitiesMapping } from "../../../API/OpportunityMappingAPI";
import { Button, Input, Form, Select, Typography } from "antd";
import { useForm, Controller } from 'react-hook-form';

interface ShowModalProps {
    show: boolean,
    toggleShowModal: () => void,
    companyId: string
}
interface FormSubmitProps {
    panelName: string;
    year: string;
}
const ModalOpportunitiesPanels = ({ show, toggleShowModal, companyId }: ShowModalProps) => {
    const { loading, toggleLoading } = useLoading();
    const [years, setYears] = useState<any[]>([]);
    const { userEmail } = useContext(AuthContext);
    const navigate = useNavigate();
    const [opportunityMap, setOpportunityMap] = useState<OpportunityMappingModel[]>([]);
    const [form] = Form.useForm();

    const schema = yup.object().shape({
        panelName: yup.string().max(140, "Limite de caracteres excedido! Limite: 140 Caracteres").required("Por favor, insira um Nome válido!")
    });
    const { register, handleSubmit, setValue, formState: { errors }, control, reset } = useForm<FormSubmitProps>({
        resolver: yupResolver(schema)
    });

    const getAllOpportunities = async () => {
        try {

            toggleLoading(true);
            await GetAllOpportunitiesMapping(companyId).then((resp: IResponseProps) => {
                if (resp.data.length === 0) {
                    setYears([]);
                }
                setOpportunityMap(resp.data);
            }).finally(() => {


            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getAllYears = () => {
        toggleLoading(true);



        var data = opportunityMap;
        var yearsCreatedArray: any[] = [];

        data.map((a: OpportunityMappingModel) => {

            yearsCreatedArray.push(a.year);

        });



        setYears(yearsCreatedArray);

        toggleLoading(false);
    }


    const Submit = async (data: any) => {
        try {
            toggleShowModal();
            toggleLoading(true);
            let panelName = data.panelName ?? "";
            let year = data.year ?? "";
            await CreatOpportunitiesPanelsAPI(companyId, userEmail, 0, panelName, year, "").then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    toast.success(`Paniel ${panelName}, criado com sucesso!`);
                    setValue("panelName", "");
                    setValue("year", "0");
                    navigate(`/opportunitiesPanels/LinesPresentation/${resp.data.id}`);
                }
            }).finally(() => {
                toggleLoading(false);

            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }
    useEffect(() => {
        if (opportunityMap.length > 0) {
            getAllYears();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opportunityMap]);

    useEffect(() => {
        getAllOpportunities();
    }, []);

    return (
        <Modal
            title={<div style={{ marginLeft: '10px' }}>Novo Painel de Oportunidades</div>}
            open={show}
            onCancel={toggleShowModal}
            footer={() => (
                <><div className="d-flex justify-content-between">
                    <Button style={{ width: '48%' }} onClick={toggleShowModal}>Cancelar</Button>
                    <Button style={{ width: '48%' }} onClick={handleSubmit(data => Submit(data))} type="primary" >Confirmar</Button>
                </div>
                </>
            )}
        >
            <Form
                form={form}
                layout="vertical"
                className="mt-4"
            >

                <Form.Item required tooltip="Por favor, insira o nome do painel!">
                    <Controller
                        name="panelName"
                        control={control}
                        render={({ field }) => (
                            <Input
                                {...field}
                                placeholder="Nome do painel de oportunidades"
                                className="mr-2 ml-2"
                                style={{ height: '40px', width: '488px' }} />
                        )}
                    />
                </Form.Item>

                <Form.Item required tooltip="Por favor, insira o ano!" >
                    <Controller
                        name="year"
                        control={control}
                        render={({ field }) => (
                            <Select
                                {...field}
                                style={{ height: '40px', width: '488px' }}
                                placeholder="Selecione um ano"
                                optionFilterProp="label"
                                filterSort={(optionA, optionB) => {
                                    const valueA = optionA?.value ?? 0;
                                    const valueB = optionB?.value ?? 0;
                                    return valueA - valueB;
                                }}
                                options={years.filter((year, index) => years.indexOf(year) === index).map((year) => ({
                                    value: year,
                                    label: year,
                                }))}
                            />
                        )}
                    />
                </Form.Item>


            </Form>
        </Modal>
    )
}

export default ModalOpportunitiesPanels;